




















































































































































































































































































































































































































































































































































































import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import html2canvas from 'html2canvas';
import { Lang } from 'gkcoi/dist/lang';
import { DeckBuilder, Theme } from 'gkcoi/dist/type';
import { generate } from 'gkcoi';
import FleetComponent from '@/components/fleet/Fleet.vue';
import ItemList from '@/components/item/ItemList.vue';
import ShipList, { ViewShip } from '@/components/fleet/ShipList.vue';
import ItemPresetComponent from '@/components/item/ItemPreset.vue';
import FleetInfo from '@/classes/fleet/fleetInfo';
import Fleet, { FleetBuilder } from '@/classes/fleet/fleet';
import Ship, { ShipBuilder } from '@/classes/fleet/ship';
import ShipValidation from '@/classes/fleet/shipValidation';
import Item, { ItemBuilder } from '@/classes/item/item';
import Const, { Formation } from '@/classes/const';
import SiteSetting from '@/classes/siteSetting';
import ItemPreset from '@/classes/item/itemPreset';
import ItemMaster from '@/classes/item/itemMaster';
import Convert from '@/classes/convert';
import SaveData from '@/classes/saveData/saveData';

export default Vue.extend({
  name: 'FleetAll',
  components: {
    FleetComponent,
    ItemList,
    ShipList,
    ItemPresetComponent,
  },
  props: {
    value: {
      type: FleetInfo,
      required: true,
    },
    handleChangeFormation: {
      type: Function,
      required: true,
    },
    handleMinimize: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    shipListDialog: false,
    itemListDialog: false,
    itemDialogTarget: [-1, -1, -1],
    shipDialogTarget: [-1, -1],
    tab: 'fleet0',
    itemDialogWidth: 1200,
    shipDialogWidth: 1200,
    level: 120,
    levelMenu: false,
    capturing: false,
    tempShip: undefined as undefined | Ship,
    tempShipListDialog: false,
    tempShipList: [] as Ship[],
    enabledPushTempShip: true,
    bulkUpdateDialog: false,
    bulkUpdateTarget: [1, 1, 1, 1],
    itemPresetDialog: false,
    gkcoiThemes: [
      { value: 'dark', text: 'Dark' },
      { value: 'dark-ex', text: 'Dark(遠征)' },
      { value: 'light', text: 'Light' },
      { value: 'light-ex', text: 'Light(遠征)' },
      { value: 'white', text: 'White' },
      { value: '74lc', text: '74式(大型)' },
      { value: '74mc', text: '74式(中型)' },
      { value: '74sb', text: '74式(小型)' },
      { value: 'official', text: '公式' },
    ],
    gkcoiTheme: 'dark' as Theme,
    gkcoiLangs: ['jp', 'en', 'kr', 'scn', 'tcn'],
    gkcoiLang: 'jp' as Lang,
    gkcoiOutputTarget: [1, 0, 0, 0],
    generatedCanvas: undefined as undefined | HTMLCanvasElement,
    enabledOutput: false,
    generatingImage: false,
    generateError: '',
  }),
  computed: {
    fleetInfo(): FleetInfo {
      return this.value;
    },
    formations(): Formation[] {
      return Const.FORMATIONS;
    },
    isBulkUpdateTargetAll(): boolean {
      return !this.bulkUpdateTarget.some((v) => !v);
    },
  },
  methods: {
    setInfo(value: FleetInfo) {
      this.$emit('input', value);
    },
    async showItemList(fleetIndex: number, shipIndex: number, slotIndex: number) {
      const ship = this.fleetInfo.fleets[fleetIndex].ships[shipIndex];
      this.itemDialogTarget = [fleetIndex, shipIndex, slotIndex];
      await (this.itemListDialog = true);
      (this.$refs.itemList as InstanceType<typeof ItemList>).initialFilter(ship, slotIndex);
    },
    async showShipList(fleetIndex: number, shipIndex: number) {
      this.shipDialogTarget = [fleetIndex, shipIndex];
      await (this.shipListDialog = true);
      (this.$refs.shipList as InstanceType<typeof ShipList>).initialize();
    },
    showItemPreset(fleetIndex: number, shipIndex: number) {
      const ship = this.fleetInfo.fleets[fleetIndex].ships[shipIndex];
      this.shipDialogTarget = [fleetIndex, shipIndex];
      this.tempShip = cloneDeep(ship);
      this.itemPresetDialog = true;
    },
    showTempShipList(fleetIndex: number, shipIndex: number) {
      const ship = this.fleetInfo.fleets[fleetIndex].ships[shipIndex];
      this.shipDialogTarget = [fleetIndex, shipIndex];
      this.tempShip = cloneDeep(ship);
      this.tempShipListDialog = true;
      this.enabledPushTempShip = true;
    },
    pushTempShip() {
      if (this.tempShip) {
        // 一時保存リストに追加
        this.enabledPushTempShip = false;
        this.tempShipList.push(this.tempShip);
      }
    },
    popTempShip(ship: Ship) {
      const fleetIndex = this.shipDialogTarget[0];
      const index = this.shipDialogTarget[1];
      const fleet = this.fleetInfo.fleets[fleetIndex];
      // 元々いた艦娘を置き換える
      const original = fleet.ships[index];
      const items = [];
      for (let i = 0; i < ship.items.length; i += 1) {
        items.push(new Item({ item: ship.items[i] }));
      }
      fleet.ships[index] = new Ship({ ship, isEscort: original.isEscort, items });

      // 編成が更新されたため、艦隊を再インスタンス化し更新
      this.fleetInfo.fleets[fleetIndex] = new Fleet({ fleet });
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
      this.tempShipListDialog = false;
    },
    resetTempShipList() {
      // 一時保存リストリセット
      this.enabledPushTempShip = true;
      this.tempShipList = [];
    },
    putShip(viewShip: ViewShip) {
      const { ship } = viewShip;
      this.shipListDialog = false;
      const fleetIndex = this.shipDialogTarget[0];
      const index = this.shipDialogTarget[1];
      const fleet = this.fleetInfo.fleets[fleetIndex];

      // もともとここに配備されていた艦娘の装備情報を抜き取る
      const oldShip = fleet.ships[index];
      const oldItems: Item[] = oldShip.items.concat();
      const newItems: Item[] = [];

      // 元々が空の艦で、艦娘数と配置番号が一致している場合、自動で空の艦娘を追加するが6隻まで
      if (oldShip.isEmpty && index === fleet.ships.length - 1 && fleet.ships.length < 6) {
        fleet.ships.push(new Ship());
      }

      for (let slotIndex = 0; slotIndex < ship.slotCount; slotIndex += 1) {
        const slot = ship.slots[slotIndex] > 0 ? ship.slots[slotIndex] : 0;
        if (slotIndex < oldItems.length) {
          const oldItem = oldItems[slotIndex];
          const itemMaster = oldItem.data;
          if (ShipValidation.isValidItem(ship, itemMaster, slotIndex)) {
            // マスタ情報があり、装備条件を満たしている場合は装備引継ぎOK！
            newItems.push(new Item({ item: oldItem, slot }));
          } else {
            // マスタ情報なし or 装備条件を満たさなかった装備は搭載数だけセット
            newItems.push(new Item({ slot }));
          }
        } else {
          // スロット数があっていない場合も空の装備で搭載数だけセット
          newItems.push(new Item({ slot }));
        }
      }

      // 補強増設チェック
      const oldExItem = oldShip.exItem.data;
      let exItem;
      if (oldExItem.id && ShipValidation.isValidItem(ship, oldExItem, Const.EXPAND_SLOT_INDEX)) {
        exItem = new Item({ master: oldExItem, remodel: oldShip.exItem.remodel });
      } else {
        exItem = new Item();
      }

      // 元々いた艦娘を置き換える
      fleet.ships[index] = new Ship({
        master: ship,
        items: newItems,
        exItem,
        isActive: oldShip.isActive,
        hp: viewShip.hp,
        level: viewShip.level,
        luck: viewShip.luck,
        asw: viewShip.asw + Ship.getStatusFromLevel(viewShip.level, ship.maxAsw, ship.minAsw),
        area: viewShip.area,
      });

      // 編成が更新されたため、艦隊を再インスタンス化し更新
      this.fleetInfo.fleets[fleetIndex] = new Fleet({ fleet });
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    equipItem(item: Item) {
      const master = item.data;
      this.itemListDialog = false;
      const fleetIndex = this.itemDialogTarget[0];
      const shipIndex = this.itemDialogTarget[1];
      const slotIndex = this.itemDialogTarget[2];
      const fleet = this.fleetInfo.fleets[fleetIndex];
      const ship = fleet.ships[shipIndex];
      let newShip: Ship;

      // 新しい装備配列を生成
      const items = ship.items.concat();
      // 初期熟練度設定
      const initialLevels = (this.$store.state.siteSetting as SiteSetting).planeInitialLevels;
      let level = 0;
      if (initialLevels) {
        // 設定情報より初期熟練度を解決
        const initData = initialLevels.find((v) => v.id === master.apiTypeId);
        if (initData) {
          level = initData.level;
        }
      }

      if (slotIndex < items.length) {
        if (item.data.apiTypeId === 41 && ship.data.type2 === 90) {
          // 日進 & 大型飛行艇
          items[slotIndex] = new Item({
            item: items[slotIndex],
            master,
            remodel: item.remodel,
            level,
            slot: 1,
          });
        } else {
          // 装備を置き換え
          items[slotIndex] = new Item({
            item: items[slotIndex],
            master,
            remodel: item.remodel,
            level,
          });
        }
        // 装備を変更した艦娘インスタンス再生成
        newShip = new Ship({ ship, items });
      } else if (slotIndex === Const.EXPAND_SLOT_INDEX) {
        // 補強増設を変更した艦娘インスタンス再生成
        const builder: ShipBuilder = { ship, exItem: new Item({ item: ship.exItem, master, remodel: item.remodel }) };
        newShip = new Ship(builder);
      } else {
        // 搭載失敗
        return;
      }

      if (shipIndex < fleet.ships.length) {
        fleet.ships[shipIndex] = newShip;
      } else {
        return;
      }

      // 再生成した艦娘インスタンスで該当艦娘を置き換えた艦隊インスタンスを設定
      const builder: FleetBuilder = { fleet, ships: fleet.ships.concat() };
      this.fleetInfo.fleets[fleetIndex] = new Fleet(builder);
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    expandItemPreset(preset: ItemPreset) {
      const itemMasters = this.$store.state.items as ItemMaster[];
      const items: Item[] = [];
      for (let i = 0; i < preset.items.length; i += 1) {
        const item = itemMasters.find((v) => v.id === preset.items[i].id);
        if (item) {
          items.push(new Item({ master: item, remodel: preset.items[i].remodel }));
        } else {
          items.push(new Item());
        }
      }

      const fleetIndex = this.shipDialogTarget[0];
      const index = this.shipDialogTarget[1];
      const fleet = this.fleetInfo.fleets[fleetIndex];

      // もともとここに配備されていた艦娘の装備情報を抜き取る
      const oldShip = fleet.ships[index];
      const ship = oldShip.data;
      const newItems = oldShip.items.concat();

      for (let slotIndex = 0; slotIndex < newItems.length; slotIndex += 1) {
        if (slotIndex < items.length) {
          const newItem = items[slotIndex];
          if (newItem && ShipValidation.isValidItem(ship, newItem.data, slotIndex)) {
            // マスタ情報があり、装備条件を満たしている場合は装備引継ぎOK！
            // 初期熟練度設定
            const initialLevels = (this.$store.state.siteSetting as SiteSetting).planeInitialLevels;
            let level = 0;
            if (initialLevels) {
              // 設定情報より初期熟練度を解決
              const initData = initialLevels.find((v) => v.id === newItem.data.apiTypeId);
              if (initData) {
                level = initData.level;
              }
            }

            if (newItem.data.id === 138 && ship.type2 === 90) {
              // 日進 & 二式大艇
              newItems[slotIndex] = new Item({
                master: newItem.data,
                item: newItems[slotIndex],
                level,
                remodel: newItem.remodel,
                slot: 1,
              });
            } else {
              newItems[slotIndex] = new Item({
                master: newItem.data,
                item: newItems[slotIndex],
                level,
                remodel: newItem.remodel,
              });
            }
          } else {
            // 不適合、外す
            newItems[slotIndex] = new Item();
          }
        }
      }

      // 補強増設チェック
      const presetExItem = itemMasters.find((v) => v.id === preset.exItem.id);
      let exItem;
      if (presetExItem && ShipValidation.isValidItem(ship, presetExItem, Const.EXPAND_SLOT_INDEX)) {
        // 搭載可能なら入れ替え
        exItem = new Item({ master: presetExItem, remodel: preset.exItem.remodel });
      }

      // 元々いた艦娘を置き換える
      fleet.ships[index] = new Ship({
        ship: oldShip,
        items: newItems,
        exItem,
      });

      // 編成が更新されたため、艦隊を再インスタンス化し更新
      this.fleetInfo.fleets[fleetIndex] = new Fleet({ fleet });
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    onLevelMenuToggle() {
      if (!this.levelMenu) {
        // 司令部レベル変更 => サイト設定値も変更してやる
        this.setInfo(new FleetInfo({ info: this.fleetInfo, admiralLevel: this.level }));
        const setting = this.$store.state.siteSetting as SiteSetting;
        if (setting) {
          setting.admiralLevel = this.level;
          this.$store.dispatch('updateSetting', setting);
        }
      } else {
        this.level = this.fleetInfo.admiralLevel;
      }
    },
    changedFormation(formation: number) {
      this.handleChangeFormation(formation);
    },
    changedInfo() {
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    changedTab(index: number) {
      if (this.fleetInfo.mainFleetIndex === index) {
        return;
      }
      const info = new FleetInfo({ info: this.fleetInfo, mainFleetIndex: index });
      // 編成が変更されたわけではないので履歴への追加を起こさない
      info.ignoreHistory = true;
      this.setInfo(info);
    },
    resetFleetAll() {
      this.setInfo(new FleetInfo());
    },
    closeDialog() {
      this.itemListDialog = false;
      this.shipListDialog = false;
      this.itemPresetDialog = false;
    },
    changeWidth(width: number) {
      this.itemDialogWidth = width;
    },
    changeShipWidth(width: number) {
      this.shipDialogWidth = width;
    },
    captureFleet() {
      // 背景色とかを塗るフラグ立て
      this.capturing = true;
      const index = this.value.mainFleetIndex;
      const div = document.getElementsByClassName('fleet-container')[index] as HTMLDivElement;
      setTimeout(() => {
        html2canvas(div, { scale: 2, width: 1200 }).then((canvas) => {
          const link = document.createElement('a');
          link.href = canvas.toDataURL();
          link.download = `fleet_${Convert.formatDate(new Date(), 'yyyyMMdd-HHmmss')}.jpg`;
          link.click();
          this.capturing = false;
        });
      }, 10);
    },
    dragStart(e: DragEvent) {
      const target = e.target as HTMLDivElement;
      if (target && target.classList && target.classList.contains('fleet-tab')) {
        target.style.opacity = '0.4';
        target.style.backgroundColor = 'rgba(20, 120, 255, 0.2)';
        target.id = 'dragging-item';
      } else {
        return;
      }

      const transfer = e.dataTransfer as DataTransfer;
      const rect = target.getBoundingClientRect();
      if (transfer && rect) {
        transfer.setDragImage(target, rect.width / 2, rect.height);
      }
    },
    dragLeave(e: DragEvent) {
      (e.target as HTMLDivElement).style.backgroundColor = '';
    },
    dragEnter(e: DragEvent): void {
      const draggingDiv = document.getElementById('dragging-item');
      const target = e.target as HTMLDivElement;
      if (!draggingDiv || !target) {
        return;
      }
      // 受け入れ可能 背景色を青っぽく
      target.style.backgroundColor = 'rgba(255, 200, 100, 0.4)';
    },
    dropItem(e: DragEvent) {
      // 受け渡されたデータ
      const draggingDiv = document.getElementById('dragging-item');
      // そもそもドラッグ開始が正常になされているか
      if (!draggingDiv) {
        return;
      }

      // ドロップされる要素
      const target = e.target as HTMLDivElement;
      target.style.backgroundColor = '';
      if (target.id) {
        // 自身へのドロップ なにもなし
        return;
      }

      const fleetTabs = document.querySelectorAll('.fleet-tab.v-tab');
      let fromIndex = -1;
      let toIndex = -1;
      for (let i = 0; i < fleetTabs.length; i += 1) {
        if (fleetTabs[i] === target) {
          toIndex = i;
        }
        if (fleetTabs[i] === draggingDiv) {
          fromIndex = i;
        }
      }

      if (fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
        const fromFleet = this.fleetInfo.fleets[fromIndex];
        const toFleet = this.fleetInfo.fleets[toIndex];

        this.fleetInfo.fleets[toIndex] = new Fleet({ fleet: fromFleet });
        this.fleetInfo.fleets[fromIndex] = new Fleet({ fleet: toFleet });
      }
    },
    dragEnd(e: DragEvent) {
      // 後片付け
      const target = e.target as HTMLDivElement;
      if (target && target.classList && target.classList.contains('fleet-tab')) {
        target.style.opacity = '1';
        target.style.backgroundColor = '';
        target.id = '';
      }

      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    toggleBulkTarget() {
      if (this.bulkUpdateTarget.some((v) => !v)) {
        this.bulkUpdateTarget = [1, 1, 1, 1];
      } else {
        this.bulkUpdateTarget = [0, 0, 0, 0];
      }
    },
    getLevelValue(value: number) {
      return Const.PROF_LEVEL_BORDER[value];
    },
    setLevel(index: number) {
      this.bulkUpdateAllItem({ level: Const.PROF_LEVEL_BORDER[index] });
    },
    setRemodel(remodel: number) {
      this.bulkUpdateAllItem({ remodel });
    },
    resetSlot() {
      this.bulkUpdateAllItem({}, true);
    },
    setSlot(value: number) {
      this.bulkUpdateAllItem({ slot: value }, true);
    },
    setMaxLevelOnlyFighter() {
      this.bulkUpdateAllItem({ level: 120 }, false, true);
    },
    bulkUpdateAllItem(itemBuilder: ItemBuilder, isResetSlot = false, onlyFighter = false) {
      // 指定ビルダーで装備情報一括更新
      const { fleets } = this.fleetInfo;
      for (let i = 0; i < fleets.length; i += 1) {
        if (!this.bulkUpdateTarget[i]) {
          continue;
        }
        const { ships } = fleets[i];
        for (let j = 0; j < ships.length; j += 1) {
          const shipMaster = ships[j].data;
          const { items } = ships[j];
          for (let k = 0; k < items.length; k += 1) {
            if (!onlyFighter || (onlyFighter && items[k].data.isFighter)) {
              const isPlane = items[k] && items[k].data.isPlane;
              const slot = itemBuilder.slot ? Math.min(itemBuilder.slot, shipMaster.slots[k]) : shipMaster.slots[k];
              items[k] = new Item({
                item: items[k],
                slot: isResetSlot && isPlane ? slot : undefined,
                remodel: items[k].data.canRemodel ? itemBuilder.remodel : undefined,
                level: itemBuilder.level,
              });
            }
          }

          const newExItem = new Item({
            item: ships[j].exItem,
            remodel: ships[j].exItem.data.canRemodel ? itemBuilder.remodel : undefined,
            level: itemBuilder.level,
          });
          ships[j] = new Ship({ ship: ships[j], exItem: newExItem });
        }
        fleets[i] = new Fleet({ fleet: fleets[i] });
      }

      const newInfo = new FleetInfo({ info: this.fleetInfo });
      // 閉じるまで計算はさせない
      newInfo.calculated = true;
      this.setInfo(newInfo);
    },
    closeBulkUpdateDialog() {
      this.bulkUpdateDialog = false;
      this.onBulkUpdateDialogToggle();
    },
    onBulkUpdateDialogToggle() {
      if (!this.bulkUpdateDialog) {
        this.setInfo(new FleetInfo({ info: this.fleetInfo }));
      }
    },
    optimizeFighterSlot() {
      const { ships } = this.value.fleets[this.value.mainFleetIndex];
      const newShips = ShipValidation.getOptimizedFighterFleet(ships);
      this.value.fleets[this.value.mainFleetIndex] = new Fleet({ ships: newShips });
      this.setInfo(new FleetInfo({ info: this.fleetInfo }));
    },
    initializeOutput() {
      // 画像出力初期化
      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData) {
        return;
      }
      const manager = saveData.tempData[saveData.tempIndex];
      if (!manager) {
        return;
      }

      // 連合か？
      if (manager.fleetInfo.isUnion) {
        this.gkcoiOutputTarget = [1, 1, 0, 0];
      } else {
        this.gkcoiOutputTarget = [1, 0, 0, 0];
      }
      this.enabledOutput = true;
    },
    generateImage() {
      // 連打禁止
      this.enabledOutput = false;
      this.generatedCanvas = undefined;
      this.generatingImage = true;
      this.generateError = '';
      const imageArea = document.getElementById('image-area') as HTMLDivElement;
      imageArea.innerHTML = '';

      const saveData = this.$store.state.mainSaveData as SaveData;
      if (!saveData) {
        return;
      }
      const manager = saveData.tempData[saveData.tempIndex];
      if (!manager) {
        return;
      }
      const deck = Convert.createDeckBuilder(manager, true);
      if (!this.gkcoiOutputTarget[0]) delete deck.f1;
      if (!this.gkcoiOutputTarget[1]) delete deck.f2;
      if (!this.gkcoiOutputTarget[2]) delete deck.f3;
      if (!this.gkcoiOutputTarget[3]) delete deck.f4;

      const gkcoiBuilder: DeckBuilder = Object.assign(deck, {
        lang: this.gkcoiLang,
        theme: this.gkcoiTheme,
        cmt: '',
      });
      generate(gkcoiBuilder)
        .then((canvas) => {
          canvas.style.maxWidth = '100%';
          imageArea.appendChild(canvas);
          this.generatedCanvas = canvas;
          this.generatingImage = false;
        })
        .catch((e) => {
          this.generatingImage = false;
          this.generateError = e;
        });
    },
    saveImage() {
      const canvas = this.generatedCanvas;
      if (canvas) {
        const base64 = canvas.toDataURL('image/jpeg');
        const download = document.getElementById('gkcoi-download') as HTMLAnchorElement;
        download.href = base64;
        download.download = `fleet_${Convert.formatDate(new Date(), 'yyyyMMdd-HHmmss')}.jpg`;
        download.click();
      }
    },
    openGkcoiPage() {
      window.open('https://github.com/Nishisonic/gkcoi/', '_blank');
    },
  },
});
